export default __webpack_public_path__ + "static/media/twitter.72058be6.svg";